import { render, staticRenderFns } from "./cabinet-fl44-unknown-volume-card-info-links.vue?vue&type=template&id=0c366bda&"
import script from "./cabinet-fl44-unknown-volume-card-info-links.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-unknown-volume-card-info-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c366bda')) {
      api.createRecord('0c366bda', component.options)
    } else {
      api.reload('0c366bda', component.options)
    }
    module.hot.accept("./cabinet-fl44-unknown-volume-card-info-links.vue?vue&type=template&id=0c366bda&", function () {
      api.rerender('0c366bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/partials/cabinet-fl44-unknown-volume-card-info-links.vue"
export default component.exports